import Axios from 'axios';
import store from "@/store";
import {Toast, Dialog} from "vant";

const localAxios = Axios.create({
    baseURL: store.state.config.local,
    timeout: store.state.config.timeout,
});

/**
 * 请求拦截器,记录请求信息
 */
localAxios.interceptors.request.use(
    function(config) {
        config.headers = {'X-Hw-Token': store.state.pdaToken,'X-CSRF-TOKEN':store.state.csrfToken};
        if (store.state.config.methodOverride && (config.method === 'put' || config.method === 'delete')) {
            config.headers['X-HTTP-Method-Override'] = config.method;
            config.method = 'post';
        }
        config.baseURL = store.state.config.local;
        config.timeout = store.state.config.timeout;
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

/**
 * 响应拦截器，处理响应信息
 * @param params
 * @param silent 是否显示接口调用返回的错误信息
 * @param confirmInfo 手动关闭接口调用返回的错误信息弹窗
 */
const localAxiosRequest = function (params = {}, silent = false, confirmInfo = false) {
    return localAxios
        .request(params)
        .then(({ status = null, data = null }) => {
            if (status === 200) {
                if(data.code === 0){
                    return Promise.resolve(data.data);
                }else if(data.code === 1){
                    if(silent){
                        Toast({message: data.msg});
                    }else if(confirmInfo){
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                        });
                    }
                    return Promise.reject(data.msg);
                }
            } else {
                return Promise.reject(data.msg);
            }
        },(err) => {
            errHandler(err);
        });
};


/**
 * 响应拦截器，处理响应信息
 * @param params
 * @param silent 是否显示接口调用返回的错误信息
 * @param confirmInfo 手动关闭接口调用返回的错误信息弹窗
 */
export const localAxiosRequest2 = function (params = {}, silent = false, confirmInfo = false) {
    return localAxios
        .request(params)
        .then(({ status = null, data = null }) => {
            if (status === 200) {
                if(data.code === 0){
                    return Promise.resolve(data);
                }else if(data.code === 1){
                    if(silent){
                        Toast({message: data.msg});
                    }else if(confirmInfo){
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                        });
                    }
                    return Promise.resolve(data);
                }
            } else {
                return Promise.reject(data);
            }
        },(err) => {
            errHandler(err);
        });
};


const centerAxios = Axios.create({
    baseURL: store.state.baseConfig['center'],
    timeout: store.state.config.timeout,
});

/**
 * 请求拦截器,记录请求信息
 */
centerAxios.interceptors.request.use(
    function(config) {
        config.headers = {'X-Hw-Token': store.state.pdaToken,'X-CSRF-TOKEN':store.state.csrfToken};
        if (store.state.config.methodOverride && (config.method === 'put' || config.method === 'delete')) {
            config.headers['X-HTTP-Method-Override'] = config.method;
            config.method = 'post';
        }
        config.baseURL = store.state.baseConfig['center'];
        config.timeout = store.state.config.timeout;
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

/**
 * 响应拦截器，处理响应信息
 * @param params
 * @param silent 是否显示接口调用返回的错误信息
 */
const centerAxiosRequest = function (params = {}, silent = false) {
    return centerAxios
        .request(params)
        .then(({ status = null, data = null }) => {
            if (status === 200) {
                if(data.code === 0){
                    return Promise.resolve(data.data);
                }else if(data.code === 1){
                    if(silent){
                        Toast({message: data.msg});
                    }
                    return Promise.reject(data.msg);
                }
            } else {
                return Promise.reject(data.msg);
            }
        },(err) => {
            errHandler(err);
        });
};

const errHandler = function (err) {
    console.error(err);
    if(err && err.request && err.request.status === 500) {
        // const errText = JSON.parse(err.request.response);
        const errText = err.request.responseText;
        if(errText){
            Toast(errText);
        }else{
                Toast("Error");
        }
    }
    if(err && err.request && err.request.status === 401) {
        Toast('会话过期,请重新登录');
        store.commit('setUser', {});
        store.commit('setInstitution', '');
        store.commit('setCartNum', '');
        store.commit('addToken', '');

        // 当会话已过期, 不需要再调用退出接口.
        // let url = store.state.config['pda.logout.url'];
        // getSearchConfs()
        //     .then((data) => {
        //         if(data){
        //             url = data.baseConfs['pda.logout.url'];
        //         }
        //     })
        //     .catch(err => console.error(err))
        //     .finally(() =>  window.location.replace(url));
    }
};

export  {localAxiosRequest, centerAxiosRequest,};
